import React from 'react'
import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useKaraoke } from 'hooks/karaoke'

export const Back = () => {
  const { gobackBuildStep } = useKaraoke()
  return (
    <Button title='next' onClick={gobackBuildStep}>
      <ArrowLeftOutlined />
      Go back
    </Button>
  )
}
